import cls from "./Loader.module.css";

export const Loader = () => {
    return (
        <div className={cls.loader}>
            <span className={cls["loader-item"]} />
            <span className={cls["loader-item"]} />
            <span className={cls["loader-item"]} />
        </div>
    );
};
